import { lazy, Suspense, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import HomeStickyCTA from "@/components/HomeStickyCTA";

const UrgencySection = lazy(() => import("@/components/UrgencySection"));
const ComparisonSection = lazy(() => import("@/components/ComparisonSection"));
const StorySection = lazy(() => import("@/components/StorySection"));
const ProcessSection = lazy(() => import("@/components/ProcessSection"));
const CaseStudySection = lazy(() => import("@/components/CaseStudySection"));
const KnowledgeTeaserSection = lazy(() => import("@/components/KnowledgeTeaserSection"));
const LeadForm = lazy(() => import("@/components/LeadForm"));
const FAQSection = lazy(() => import("@/components/FAQSection"));
const PartnerGrid = lazy(() => import("@/components/PartnerGrid"));
const NewsletterSection = lazy(() => import("@/components/NewsletterSection"));
const NewsletterStickyBar = lazy(() => import("@/components/NewsletterStickyBar"));
const NewsletterExitIntentModal = lazy(() => import("@/components/NewsletterExitIntentModal"));
const Footer = lazy(() => import("@/components/Footer"));

const Index = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.substring(1);

    let cancelled = false;
    const tryScroll = () => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return true;
      }
      return false;
    };

    if (tryScroll()) return;

    const observer = new MutationObserver(() => {
      if (cancelled) return;
      if (tryScroll()) {
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    const safety = setTimeout(() => {
      cancelled = true;
      observer.disconnect();
    }, 3000);

    return () => {
      cancelled = true;
      observer.disconnect();
      clearTimeout(safety);
    };
  }, [location.hash, location.key]);

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main>
        <HeroSection />
        <Suspense fallback={null}>
          <UrgencySection />
          <ComparisonSection />
          <ProcessSection />
          <KnowledgeTeaserSection />
          <CaseStudySection />
          <StorySection />
          <PartnerGrid />
          <LeadForm />
          <NewsletterSection />
          <FAQSection />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
      </Suspense>
      <HomeStickyCTA />
      <Suspense fallback={null}>
        <NewsletterStickyBar scrollToLocal dismissKey="elevest:newsletter-sticky:startseite:dismissed" />
        <NewsletterExitIntentModal source="exit-intent:startseite" />
      </Suspense>
    </div>
  );
};

export default Index;
